import { CheckOutlined, SearchOutlined } from "@ant-design/icons";
import { Input } from "antd"
import { useEffect, useState } from "react";
import EmptyData from "./EmptyData";
import { PURPLE } from "../../styles/styleUtils";
import { getTranslated, getThemedImage } from "../../utils/CommonUtils";
import { useSelector } from "react-redux";

/**
 * @param {*} props 
 * @param {Array[Object]} props.listItems Select options in { label, value }[] pair format
 * @example props.listItems => [{ value: "telecom", label: "Telecom" },
             { value: "fr_openIP", label: "FR_openIP" }]
   @param {String} props.value Selected item value
   @param {String} props.placeholder placeholder text 
   @param {Function} props.handleListBoxSelect function to get list box selection
 */

const ListBox = (props) => {

    const [options, setOptions] = useState(props.listItems)
    const [value, setValue] = useState()
    const [searchValue, setSearchValue] = useState()
    const [hoveredItem, setHoveredItem] = useState()

    const dict = useSelector(state => state.common.dict)

    useEffect(() => {
        setOptions(props.listItems)
    }, [props.listItems])

    useEffect(() => {
        setValue(props.value)
    }, [props.value])

    const handleSearch = (event) => {
        if (event?.target) {
            setSearchValue(event.target.value)

            const optn = props.listItems.filter(val => val?.label?.toUpperCase().includes(event.target.value.toUpperCase()))
            setOptions(optn.length ? optn : [{ value: "null" }])
        }
    }

    const handleSelect = (value) => {
        setValue(value)
        props.handleListBoxSelect && props.handleListBoxSelect(value)
    }

    return <div className={`list-dd dropdown-content ${props.className} ${props.disabled ? "diable-element" : ""}`}>
        <Input
            size="large"
            value={searchValue}
            onChange={handleSearch}
            className="listbox-input"
            placeholder={props.placeholder || getTranslated(dict, "LABEL_SEARCH")}
            prefix={<SearchOutlined style={{ color: PURPLE }} />}
        />
        <div className="dd-search-items">
            {(options?.length === 1 && options[0].value === "null") ?
                <EmptyData message={getTranslated(dict, "MSG_NO_DATA")} /> :
                <>
                    {options?.map((data, index) => {
                        return <div
                            key={index}
                            className={`dd-item custom-sel-option ${value === data.value ? 'active-sel' : ''}`}
                            onClick={() => handleSelect(data.value)}
                            onMouseOver={() => setHoveredItem(data.value)}
                            onMouseLeave={() => data.value === hoveredItem && setHoveredItem("")}
                        >
                            <>
                                {value === data.value ?
                                    <CheckOutlined color={PURPLE} className="custom-sel-span" /> : <div className="custom-sel-span"></div>}
                                <span className="text-overflow-ellipsis custom-sel-span">{data.label}</span>
                                {data?.imageIcon ?
                                    <div className="cmnt-icon">
                                        <img
                                            title={data.help}
                                            src={getThemedImage(((hoveredItem === data.value || value === data.value) ? `light-${data.imageIcon}` : `dark-${data.imageIcon}`))}
                                            alt="img"
                                        />
                                    </div> :
                                    <></>
                                }
                            </>
                        </div>
                    })}
                </>
            }
        </div>
    </div>

}

export default ListBox